import React, { useState, useEffect } from "react";

import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Input,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Label,
  FormFeedback,
  UncontrolledAlert,
  Spinner,
  FormGroup,
  Button,
  CardTitle,
  CardSubtitle
} from "reactstrap";
import { post, get } from "../../Services/RestAPIService";
import { useFormik } from "formik";
import * as Yup from "yup";
import classnames from "classnames";
import { Link } from "react-router-dom";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { useNavigate } from "react-router-dom";

import SelectCategories from "./FormComponents/SelectCategories";
import SelectTime from "./FormComponents/SelectTime";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

const FormWizard = () => {

  const animatedComponents = makeAnimated();
  const [activeTab, setactiveTab] = useState(1);
  const [activeTabProgress, setactiveTabProgress] = useState(1);
  const [progressValue, setprogressValue] = useState(25);
  const [activeTabVartical, setoggleTabVertical] = useState(1);
  const [profileImage, setProfileImage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isDisabledC, setIsDisabledC] = useState(false);


  const [id, setId] = useState(null);


  const [alert, setAlert] = useState({
    color: "",
    message: "",
    visible: false,
    strongM: ""
  });

  const navigate = useNavigate();

  const validation = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      gender: "",
      mobileNumber: "",
      profileImage: ""
    },

    validationSchema: Yup.object({
      firstName: Yup.string().required("Please Enter First Name"),
      lastName: Yup.string().required("Please Enter Last Name"),
      email: Yup.string().email("Invalid email address").required("Please Enter Email"),
      gender: Yup.string().required("Please Select Gender"),
      mobileNumber: Yup.string().required("Please Enter Mobile Number"),
      // profileImage: Yup.mixed().test("file", "Please select an image file", file => file && file.type.includes("image/"))
    }),

    onSubmit: async (values, { resetForm }) => {
      setIsLoading(true);
      console.log("response")

      const formData = {
        "first_name": values.firstName,
        "last_name": values.lastName,
        "email": values.email,
        "gender": values.gender,
        "mobile_number": values.mobileNumber,
        "profile_image": profileImage,
        "user_type": "Consultant"
      }

      console.log(formData)
      try {
        const response = await post("v1/signup/", formData);
        console.log(response, "response")
        if (response.status <= 399) {
          setAlert({
            color: "success",
            visible: true,
            message: "Doctor registered successfully!",
            strongM: "Success!"
          });
          setTimeout(() => {
            setAlert({ visible: false });
          }, 3000);

          // Navigate to the next step if applicable
          // navigate('/next-step');
          setId(response.data.user.id)
          setactiveTab(2);

          resetForm(); // Reset the form
          setProfileImage(null);
        } else {
          let errorMessage = "An error occurred while registering the doctor.";
          for (const key in response.data) {
            if (Array.isArray(response.data[key]) && response.data[key].length > 0) {
              errorMessage = `${key}: ${response.data[key][0]}`;
              break;
            }
          }

          setAlert({
            color: "danger",
            visible: true,
            message: errorMessage,
            strongM: "Error!"
          });
          setTimeout(() => {
            setAlert({ visible: false });
          }, 3000);
        }
      } catch (error) {
        console.error('Error registering doctor:', error);
        let errorMessage = "An error occurred while registering the doctor.";


        setAlert({
          color: "danger",
          visible: true,
          message: `${errorMessage || "An error occurred while registering the doctor."}`,
          strongM: "Error!"
        });
        setTimeout(() => {
          setAlert({ visible: false });
        }, 3000);
      } finally {
        setIsLoading(false);
      }
    }
  })


  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result;
        setProfileImage(base64String);
      };
      reader.readAsDataURL(file);
    }
  }

  const handleAlerts = (value) => {
    setAlert({
      color: value.color,
      visible: value.visible,
      message: value.message,
      strongM: value.strongM
    });
    setTimeout(() => {
      setAlert({ visible: false });
    }, 3000);
  }



  function toggleTab(tab) {
    if (activeTab !== tab) {
      if (tab >= 1 && tab <= 4) {
        setactiveTab(tab);
      }
    }
  }

  function toggleTabVertical(tab) {
    if (activeTabVartical !== tab) {
      if (tab >= 1 && tab <= 4) {
        setoggleTabVertical(tab);
      }
    }
  }

  function toggleTabProgress(tab) {
    if (activeTabProgress !== tab) {
      if (tab >= 1 && tab <= 4) {
        setactiveTabProgress(tab);

        if (tab === 1) {
          setprogressValue(25);
        }
        if (tab === 2) {
          setprogressValue(50);
        }
        if (tab === 3) {
          setprogressValue(75);
        }
        if (tab === 4) {
          setprogressValue(100);
        }
      }
    }
  }


  useEffect(() => {

    
    if (id=== null && activeTab !== 1) {
      setAlert({
        color: "danger",
        visible: true,
        message: "You have to Firstly Register Doctor as ID is Not Available.",
        strongM: "Error!"
      });
     
    }else{
      if (id === null){
        setAlert({ visible: false });
      }
    }
}, [activeTab]);


  document.title = "Form Wizard | Llosana";


  return (
    <React.Fragment>

      {alert.visible && <UncontrolledAlert className="Alert_Additions_Log" color={`${alert.color || "warning"}`} role="alert">
        {alert?.message || "Welcome"}
      </UncontrolledAlert>}

      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs maintitle="Home" title="Consultant" breadcrumbItem="Register Consultant" />

          <Row>
            <Col sm="12">
              <Card>
                <CardBody>
                  <h4 className="card-title mb-4">Register Consultant</h4>
                  <div className="form-horizontal form-wizard-wrapper wizard clearfix">
                    <div className="steps clearfix">
                      <ul>
                        <NavItem
                          className={classnames({ current: activeTab === 1 })}>
                          <NavLink
                            className={classnames({ current: activeTab === 1 })}
                            // onClick={() => {
                            //   setactiveTab(1);
                            // }}
                          >
                            <span className="number">1.</span>{" "}
                            Consultant Details
                          </NavLink>
                        </NavItem>
                        <NavItem className={classnames({ current: activeTab === 2 })}>
                          <NavLink
                            className={classnames({ active: activeTab === 2 })}
                            // onClick={() => {
                            //   setactiveTab(2);
                            // }}
                          >
                            <span className="number">2.</span>{" "}
                            Categories Selection
                          </NavLink>
                        </NavItem>
                        <NavItem className={classnames({ current: activeTab === 3 })}>
                          <NavLink
                            className={classnames({ active: activeTab === 3 })}
                            // onClick={() => {
                            //   setactiveTab(3);
                            // }}
                          >
                            <span className="number">3.</span>
                            Timings
                          </NavLink>
                        </NavItem>
                        <NavItem className={classnames({ current: activeTab === 4 })}>
                          <NavLink
                            className={classnames({ active: activeTab === 4 })}
                            // onClick={() => {
                            //   setactiveTab(4);
                            // }}
                          >
                            <span className="number">3.</span>
                            Confirm Detail
                          </NavLink>
                        </NavItem>
                      </ul>
                    </div>
                    <div className="content clearfix">
                      <TabContent
                        activeTab={activeTab}
                        className="body"
                      >
                        <TabPane tabId={1}>
                          {/* <Form> */}

                          <Row>
                            <Col lg={6}>
                              <Card>
                                <CardBody>
                                  <CardTitle>Register New Doctor</CardTitle>
                                  <CardSubtitle className="mb-3">
                                    Fill in the details below to register a new doctor.
                                  </CardSubtitle>
                                  <Form onSubmit={validation.handleSubmit} id="DocRegister">
                                    <div className="mb-3">
                                      <Label className="form-label">First Name</Label>
                                      <Input
                                        type="text"
                                        name="firstName"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.firstName || ""}
                                        invalid={validation.touched.firstName && validation.errors.firstName}
                                      />
                                      {validation.touched.firstName && validation.errors.firstName && (
                                        <FormFeedback type="invalid">{validation.errors.firstName}</FormFeedback>
                                      )}
                                    </div>

                                    <div className="mb-3">
                                      <Label className="form-label">Last Name</Label>
                                      <Input
                                        type="text"
                                        name="lastName"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.lastName || ""}
                                        invalid={validation.touched.lastName && validation.errors.lastName}
                                      />
                                      {validation.touched.lastName && validation.errors.lastName && (
                                        <FormFeedback type="invalid">{validation.errors.lastName}</FormFeedback>
                                      )}
                                    </div>

                                    <div className="mb-3">
                                      <Label className="form-label">Email</Label>
                                      <Input
                                        type="email"
                                        name="email"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.email || ""}
                                        invalid={validation.touched.email && validation.errors.email}
                                      />
                                      {validation.touched.email && validation.errors.email && (
                                        <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                                      )}
                                    </div>

                                    <div className="mb-3">
                                      <Label className="form-label">Gender</Label>
                                      <Input
                                        type="select"
                                        name="gender"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.gender || ""}
                                        invalid={validation.touched.gender && validation.errors.gender}
                                      >
                                        <option value="">Select Gender</option>
                                        <option value="Male">Male</option>
                                        <option value="Female">Female</option>
                                        <option value="Other">Other</option>
                                      </Input>
                                      {validation.touched.gender && validation.errors.gender && (
                                        <FormFeedback type="invalid">{validation.errors.gender}</FormFeedback>
                                      )}
                                    </div>

                                    <div className="mb-3">
                                      <Label className="form-label">Mobile Number</Label>
                                      <Input
                                        type="text"
                                        name="mobileNumber"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.mobileNumber || ""}
                                        invalid={validation.touched.mobileNumber && validation.errors.mobileNumber}
                                      />
                                      {validation.touched.mobileNumber && validation.errors.mobileNumber && (
                                        <FormFeedback type="invalid">{validation.errors.mobileNumber}</FormFeedback>
                                      )}
                                    </div>

                                    <div className="mb-3">
                                      <Label className="form-label">Profile Image</Label>
                                      <Input
                                        type="file"
                                        name="profileImage"
                                        onChange={handleImageChange}
                                      />
                                      {validation.errors.profileImage && (
                                        <FormFeedback type="invalid">{validation.errors.profileImage}</FormFeedback>
                                      )}
                                    </div>

                                    <div className="d-flex flex-wrap gap-2">
                                      {/* <Button type="submit" color="primary" disabled={isLoading}>
                                        {isLoading ? (
                                          <Spinner size="sm" color="light" />
                                        ) : (
                                          "Register"
                                        )}
                                      </Button> */}
                                    </div>
                                  </Form>
                                </CardBody>
                              </Card>
                            </Col>
                          </Row>


                          {/* </Form> */}
                        </TabPane>
                        <TabPane tabId={2}>

                          {/* Categories.js */}
                      
                          <SelectCategories OnSubmit={null} Response={(value)=>{toggleTab(value)}}  Data={id} Alerts={(value)=>{handleAlerts(value)}} Loading={(value)=>{setIsLoading(value)}} IsDisabled={(value)=>{setIsDisabledC(value)}} />

                        </TabPane>
                        <TabPane tabId={3}>


                          {/* Time Data */}

                          <SelectTime OnSubmit={null} Response={(value)=>{toggleTab(value)}}  Data={id} Alerts={(value)=>{handleAlerts(value)}} Loading={(value)=>{setIsLoading(value)}} IsDisabled={(value)=>{setIsDisabled(value)}}/>

                        </TabPane>
                        <TabPane tabId={4}>
                          <div className="row justify-content-center">
                            <Col lg="6">
                              <div className="text-center">
                                <div className="mb-4">
                                  <i className="mdi mdi-check-circle-outline text-success display-4" />
                                </div>
                                <div>
                                  <h5>Thank You</h5>
                                  <p className="text-muted">
                                    New Consultant is Registered.
                                  </p>
                                </div>
                              </div>
                            </Col>
                          </div>
                        </TabPane>
                      </TabContent>
                    </div>
                    <div className="actions clearfix">
                      <ul>
                        <li
                          className={
                            activeTab === 1 ? "previous disabled" : "previous"
                          }
                        >
                          {/* <Link
                            to="#"
                            onClick={() => {
                              toggleTab(activeTab - 1);
                            }}
                          >
                            Previous
                          </Link> */}
                        </li>
                        <li
                          className={activeTab === 4 ? "next disabled" : "next"}
                        >

                          {activeTab === 3 && <Button form="SubmitTimeings" type="submit" color="primary" disabled={isLoading || isDisabled}>
                            {isLoading ? (
                              <Spinner size="sm" color="light" />
                            ) : (
                              "Submit Timings"
                            )}
                          </Button>}



                          {activeTab === 1 && <Button form="DocRegister" type="submit" color="primary" disabled={isLoading}>
                            {isLoading ? (
                              <Spinner size="sm" color="light" />
                            ) : (
                              "Register Doctor"
                            )}
                          </Button>}



                          {activeTab === 2 && <Button form="CategoriesSelect" type="submit" color="primary"disabled={isLoading || isDisabledC}>
                            {isLoading ? (
                              <Spinner size="sm" color="light" />
                            ) : (
                              "Submit Exercises"
                            )}
                          </Button>}


                        </li>
                      </ul>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default FormWizard;